var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"reset-button",on:{"click":_vm.reset}},[_vm._v("RESET")])}
var staticRenderFns = []

export { render, staticRenderFns }